import { render, staticRenderFns } from "./OrderViewActionSendInvoice.vue?vue&type=template&id=0889b7e8&scoped=true&"
import script from "./OrderViewActionSendInvoice.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionSendInvoice.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewActionSendInvoice.vue?vue&type=style&index=0&id=0889b7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889b7e8",
  null
  
)

export default component.exports